import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  terms: { content: '', loading: false, error: '' },
  privacy: { content: '', loading: false, error: '' },
  recordingConsent: { content: '', loading: false, error: '' },
  paymentTerms: { content: '', loading: false, error: '' },
  dataProcessing: { content: '', loading: false, error: '' },
};

const legalSlice = createSlice({
  name: 'legal',
  initialState,
  reducers: {
    fetchLegalStart(state, action) {
      const doc = action.payload;
      state[doc].loading = true;
      state[doc].error = '';
    },
    fetchLegalSuccess(state, action) {
      const { doc, content } = action.payload;
      state[doc].loading = false;
      state[doc].content = content;
      state[doc].error = '';
    },
    fetchLegalFailure(state, action) {
      const { doc, error } = action.payload;
      state[doc].loading = false;
      state[doc].error = error;
    },
  },
});

export const { fetchLegalStart, fetchLegalSuccess, fetchLegalFailure } = legalSlice.actions;
export default legalSlice.reducer;
